import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';

export interface SiteConfig {
  appName: string;
  headerBrand: string;
  companyName: string;
  companyEmail: string;
  supportEmail: string;
  websiteUrl: string;
  emailFooter: string;
  logoUrl: string;
  // Brand colors for consistent theming
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  successColor: string;
  errorColor: string;
  backgroundColor: string;
  textColor: string;
  mutedTextColor: string;
}

// Default configuration values (fallback)
const DEFAULT_CONFIG: Readonly<SiteConfig> = {
  appName: "DAFCG CRM",
  headerBrand: "DAFCG",
  companyName: "DAFCG",
  companyEmail: "noreply@makably.com",
  supportEmail: "support@makably.com",
  websiteUrl: "https://dafcg.com",
  emailFooter: "DAFCG CRM System",
  logoUrl: "", // No default logo
  // Brand colors for consistent theming
  primaryColor: "#0f172a", // slate-900 - primary brand color
  secondaryColor: "#475569", // slate-600 - secondary brand color
  accentColor: "#f59e0b", // amber-500 - accent/warning color
  successColor: "#10b981", // emerald-500 - success color
  errorColor: "#ef4444", // red-500 - error color
  backgroundColor: "#f8fafc", // slate-50 - light background
  textColor: "#1e293b", // slate-800 - primary text
  mutedTextColor: "#64748b", // slate-500 - muted text
} as const;

export function useSiteConfig() {
  const config = useQuery(api.siteConfig.getSiteConfig);
  
  // Return default config while loading or if query fails
  return config ?? DEFAULT_CONFIG;
}

// Hook to get a single config value
export function useConfigValue(key: keyof SiteConfig) {
  const config = useSiteConfig();
  return config[key];
}